/*import { Analytics } from '../../views/ts/components/Analytics';
import { CookiesConsent } from '../../views/twig/components/CookiesConsent';*/
import { Carousel } from '../../views/ts/components/Carousel';
import { Collapse } from '../../views/ts/components/Collapse';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Menu } from '../../views/twig/components/Menu';
import { ButtonToggleAccessibility } from '../twig/components/ButtonToggleAccessibility';
import { CarouselComponent } from '../twig/components/Carousel';
import { Header } from '../twig/components/Header';
import { SubMenu } from '../twig/components/SubMenu';
import { ImageToggle } from '../twig/modules-section/image_toggle';
import { Banner } from '../twig/modules/banner';
import { News } from '../twig/modules/news';
import { Timeline } from '../twig/modules/timeline';
import { FrontPage } from '../twig/pages/front-page';
/*(new Analytics()).init();*/
(new Carousel()).init();
(new Collapse()).init();
(new LazyLoader()).init();
(new Menu()).init();
(new FrontPage()).init();
(new CarouselComponent()).init();
(new ImageToggle()).init();
(new Banner()).init();
(new News()).init();
(new Timeline()).init();
(new SubMenu()).init();
(new ButtonToggleAccessibility()).init();
(new Header()).init();
// Always at the end
/*(new CookiesConsent()).init();*/
